var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-app-bar',{attrs:{"absolute":"","color":"#283271","app":""}},[_c('NavbarP')],1),_c('v-main'),_c('v-footer',{attrs:{"color":"#283271","padless":""}},[_c('footerP')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }